import React from 'react';
const SuccessSVG = ({ color = 'black', className, onClick }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='14'
      height='15'
      viewBox='0 0 14 15'
      fill='none'
      className={className}
      onClick={onClick}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1 7.50006C1.00021 4.63779 3.02226 2.17425 5.82954 1.61604C8.63686 1.05783 11.4475 2.56041 12.5427 5.20487C13.6379 7.84933 12.7126 10.8991 10.3326 12.4892C7.95265 14.0793 4.78087 13.7667 2.75704 11.7427C1.63192 10.6174 0.999889 9.09134 1 7.50006Z'
        stroke='#01931A'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4 7.50005L5.9996 9.49965L9.99965 5.50049'
        stroke='#01931A'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default SuccessSVG;
